import Swiper from "swiper";
import { Thumbs, Navigation, Controller, Autoplay } from "swiper/modules";

document.addEventListener("DOMContentLoaded", () => {
  const mainSwiperSelector = ".customer-reviews-main-swiper";
  const thumbsSwiperSelector = ".customer-reviews-thumbs-swiper";

  const mainSwiperEl = document.querySelector(mainSwiperSelector);
  const thumbsSwiperEl = document.querySelector(thumbsSwiperSelector);

  const MOBILE_BREAKPOINT = 768; // Match SCSS breakpoint

  if (mainSwiperEl && thumbsSwiperEl) {
    let thumbsSwiper = null;
    let mainSwiperInstance = null;

    function initCustomerReviewsSwipers() {
      // Destroy existing instances if they exist
      if (thumbsSwiper && typeof thumbsSwiper.destroy === "function") {
        thumbsSwiper.destroy(true, true);
        thumbsSwiper = null;
      }
      if (
        mainSwiperInstance &&
        typeof mainSwiperInstance.destroy === "function"
      ) {
        mainSwiperInstance.destroy(true, true);
        mainSwiperInstance = null;
      }

      const isMobile = window.innerWidth <= MOBILE_BREAKPOINT;

      thumbsSwiper = new Swiper(thumbsSwiperEl, {
        modules: [Controller],
        direction: isMobile ? "horizontal" : "vertical",
        slidesPerView: isMobile ? 3 : 2, // Show 3 thumbs horizontally on mobile
        spaceBetween: 15,
        watchSlidesProgress: true,
        freeMode: !isMobile, // Free mode for vertical, not for horizontal
        centeredSlides: false,
        loop: false,
        centerInsufficientSlides: true,
      });

      mainSwiperInstance = new Swiper(mainSwiperEl, {
        modules: [Thumbs, Controller, Autoplay, Navigation],
        spaceBetween: 10,
        /* loop: true,
        autoplay: {
          delay: 7000,
          disableOnInteraction: false,
        }, */
        navigation: {
          nextEl: ".customer-reviews-thumbs-wrapper .swiper-button-next",
          prevEl: ".customer-reviews-thumbs-wrapper .swiper-button-prev",
        },
        thumbs: {
          swiper: thumbsSwiper,
        },
        on: {
          slideChangeTransitionEnd: function () {
            if (
              this.realIndex !== thumbsSwiper.realIndex &&
              thumbsSwiper.slides[this.realIndex]
            ) {
              // For non-looping thumbs, slideTo is more appropriate
              thumbsSwiper.slideTo(this.realIndex);
            }
          },
        },
      });
    }

    // Initial setup
    initCustomerReviewsSwipers();

    // Re-initialize on resize
    let resizeTimeout;
    window.addEventListener("resize", () => {
      clearTimeout(resizeTimeout);
      resizeTimeout = setTimeout(() => {
        initCustomerReviewsSwipers();
      }, 250);
    });
  }
});
